<script setup lang="ts">
/**
 * "Don't have an account? Sign up" — the footer that replaces the old tab row
 * (Figma `66:46882`). Login and sign up are separate screens now; this is the
 * only way between them.
 */
defineProps<{
  prompt: string
  actionLabel: string
}>()

const emit = defineEmits<{ switch: [] }>()
</script>

<template>
  <p class="fair-auth-switch">
    {{ prompt }}
    <button
      type="button"
      class="fair-auth-form__link"
      @click="emit('switch')"
    >
      {{ actionLabel }}
    </button>
  </p>
</template>
